import { render } from "./Realizations.vue?vue&type=template&id=28e445f8&scoped=true&ts=true"
import script from "./Realizations.ts?vue&type=script&lang=ts&external"
export * from "./Realizations.ts?vue&type=script&lang=ts&external"

import "./Realizations.vue?vue&type=style&index=0&id=28e445f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e445f8"]])

export default __exports__